const translationsRo = {
    light: 'Luminoasă',
    dark: 'Întunecată',
    theme: 'Temă:',
    ro: 'Română',
    en: 'Engleză',
    language: 'Limbă:',
    RO: 'Romania',
    country: 'Țara:',
    reset: 'Resetează Setările',
    open: 'Deschide',
    selectDomain: 'Selectează un domeniu:',
    exportExcel: 'Exportă Excel',
    domain: 'Domeniu',
    user: 'Utilizator',
    timestamp: 'Data',
    action: 'Acțiune',
    applicationload: 'Deschidere aplicație',
    applicationclosed: 'Închidere aplicație',
    lockerselected: 'Easybox selectat',
    lockerfavourite: 'Easybox favorit',
    to: 'De la',
    from: 'Până la',
    noResults: 'Nu există rezultate',
    hello: 'bună',
    clients: 'Clienți',
    addClient: 'Adaugă Client',
    search: 'Caută',
    favouriteLockerEnabled: 'Locker favorit activat',
    hosts: 'Domenii',
    hostAdded: 'Noul domeniu a fost adăugat!',
    hostRemoved: 'Domeniul a fost șters!',
    favLockerChanged: `Opțiunea 'FavouriteLockerEnabled' a fost modificată!`,
    client: 'Clientul',
    allowedHosts: 'Domenii permise:',
    addHostButton: 'Adaugă domeniu',
    deleteClient: 'Șterge client',
    areYouSure: 'Ești sigur că vrei să ștergi clientul?',
    clientDeleted: 'Clientul a fost șters!',
    fetchError: 'A apărut o eroare!',
    getClientError: 'Nu s-au putut încărca detaliile clientului. Vă rugăm reîncercați!',
    getClientsError: 'Nu s-au putut încărca detaliile clienților. Vă rugăm reîncercați!',
    addClientError: 'Adăugarea clientului a eșuat. Vă rugăm reîncercați!',
    editClientError: 'Editarea clientului a eșuat. Vă rugăm reîncercați!',
    getActionsReportError: 'Nu s-a putut încărca raportul de acțiuni. Vă rugăm reîncercați!',
    deleteClientError: 'Ștergerea clientului a eșuat. Vă rugăm reîncercați!',
    duplicateHostError: 'Domeniile duplicat nu sunt permise. Vă rugăm reîncercați cu alte domenii.',
    invalidHostError: 'Domeniul este invalid! Vă rugăm reîncercați!',
    clientIdError: 'Id-ul clientului este invalid! Vă rugăm reîncercați!',
    getHostsError: 'Nu s-au putut încărca domeniile! Vă rugăm reîncercați!',
    badRequestError: 'Un request greșit a fost detectat. Vă rugăm reîncercați!',
    notFoundError: 'Datele cerute nu au fost găsite. Vă rugăm reîncercați!',
    internalServerError: 'Ceva nu a mers bine. Vă rugăm reîncercați!',
    historyUserAddedClient: 'a adaugat clientul.',
    userHistoryTableTitle: 'Utilizator',
    actionHistoryTableTitle: 'Modificări',
    viewHistory: 'Istoric modificări',
    noHistoryFound: 'Nu exista istoric pentru acest client',
    getHistoryError: 'Nu s-a putut incarca istoricul. Vă rugăm reîncercați!',
    cui: 'CUI',
    createdAt: 'Data adăugării',
    saveCui: 'Salvează CUI',
    cuiSaved: 'CUI-ul a fost actualizat!',
} as const;

export default translationsRo;
